import { render } from "./JobFTConsumptionDetails.vue?vue&type=template&id=3f96afbb&scoped=true"
import script from "./JobFTConsumptionDetails.vue?vue&type=script&lang=js"
export * from "./JobFTConsumptionDetails.vue?vue&type=script&lang=js"

import "./JobFTConsumptionDetails.vue?vue&type=style&index=0&id=3f96afbb&scoped=true&lang=css"
import "./JobFTConsumptionDetails.vue?vue&type=style&index=1&id=3f96afbb&lang=css"
script.render = render
script.__scopeId = "data-v-3f96afbb"

export default script